/**
*   Created by FANGlh on 2018/12/29 15:54.
*   Desc:
*/

import React,{Component} from 'react';
import './AccessNotice.css';
import line_img from '../../../style/imgs/line_img.png';
import enter_img from '../../../style/imgs/ic_enter.png';
import exit_img from '../../../style/imgs/ic_exit.png';
import moment from 'moment';


export default class ItemComp extends Component{
   constructor(props){
        super(props);
        this.state = {
            // showTime1:(this.props.itemdata.inDate==''||this.props.itemdata.inDate==null) ? this.props.itemdata.outDate : this.props.itemdata.inDate,
            showTime1:this.props.itemdata.recordDate
        }
    }
     render(){
        return(
            <div>
                {!this.props.isFirst ?  <div className="san_jiao"></div> : ''}
                <div className="timeList_sty">
                    {}
                    <div className='common-flex-column'
                         style={{height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                        {this.props.isFirst ? <div style={{flex: 1}}></div>
                            : <div style={{background: '#E9E9E9', flex: '1', width: '2px'}}></div>}
                        { this.props.itemdata.recordType == 1  ?
                            <div className="item_in_out in">进</div> :
                            <div className="item_in_out out">出</div>
                        }
                        {this.props.isLast ? <div style={{flex: 1}}></div>
                            : <div style={{background: '#E9E9E9', flex: '1', width: '2px'}}></div>}
                    </div>
                    <div style={{marginLeft:30}}>
                        <div style={{color:"#000000",fontSize:12,fontWeight:'bold'}}>{this.state.showTime1}</div>
                        {/*<div style={{color:"#333333",fontSize:12,marginTop:5}}>{this.props.itemdata.recordName}</div>*/}
                    </div>
                </div>
            </div>
        )
    }
}